import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DateFormat } from './shared.const';
import * as moment from 'moment';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            if (typeof value === 'string') {
                value = value.trim();
            }
            let mdt = moment(value, DateFormat);
            if (!mdt.isValid()) return null;
            return {
                day: mdt.date(),
                month: mdt.month() + 1,
                year: mdt.year()
            }
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): string | null {
        if (!date) return '';
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) return '';
        return mdt.format(DateFormat);
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

    parse(value: string): NgbDateStruct | null {
        if (value) {
            if (typeof value === 'string') {
                value = value.trim();
            }
            let mdt = moment(value, DateFormat)
            if (!mdt.isValid()) return null;
            return {
                day: mdt.date(),
                month: mdt.month() + 1,
                year: mdt.year()
            }
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        if (!date) return '';
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) return '';
        return mdt.format(DateFormat);
    }
}
